export enum CacheKeys {
  JOB_META = 'm',
  VERSION = 'v',
  TIMESTAMP = 't',
}
